import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';

function ParametrosFacturaNoElectronica() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    // Estados Factura
    const [consecutivo, setConsecutivo] = useState(null);
    const [prefijo, setPrefijo] = useState('');
    const [numeroConsecutivo, setNumeroConsecutivo] = useState('1');

    // Estados Nota Crédito
    const [consecutivoNC, setConsecutivoNC] = useState(null);
    const [prefijoNC, setPrefijoNC] = useState('');
    const [numeroConsecutivoNC, setNumeroConsecutivoNC] = useState('1');

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const fetchParams = async () => {
            const config = {
                headers: { Authorization: 'Bearer ' + userdata.access_token }
            };

            try {
                // Cargar cliente
                const clientRes = await axios.get('/get-client?uid=' + userdata.user_id, config);
                if (clientRes.status === 200) {
                    setClient(clientRes.data);
                    setLoggedIn(true);
                }

                // Cargar consecutivo Factura
                try {
                    const factRes = await axios.get('/consecutivo-factura-no-electronica?uid=' + userdata.user_id, config);
                    if (factRes.status === 200 && factRes.data) {
                        setConsecutivo(factRes.data);
                        setPrefijo(factRes.data.prefijo || '');
                        setNumeroConsecutivo(factRes.data.consecutivo || '1');
                    }
                } catch (e) { console.log('Sin consecutivo factura'); }

                // Cargar consecutivo Nota Crédito
                try {
                    const ncRes = await axios.get('/consecutivo-nc-no-electronica?uid=' + userdata.user_id, config);
                    if (ncRes.status === 200 && ncRes.data) {
                        setConsecutivoNC(ncRes.data);
                        setPrefijoNC(ncRes.data.prefijo || '');
                        setNumeroConsecutivoNC(ncRes.data.consecutivo || '1');
                    }
                } catch (e) { console.log('Sin consecutivo NC'); }

            } catch (error) {
                console.log('Error general:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchParams();
    }, []);

    const handleSubmitFactura = async (e) => {
        e.preventDefault();
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const data = { prefijo: prefijo, consecutivo: numeroConsecutivo };

        try {
            let response;
            if (consecutivo) {
                response = await axios.put('/consecutivo-factura-no-electronica?uid=' + userdata.user_id, data);
            } else {
                response = await axios.post('/consecutivo-factura-no-electronica?uid=' + userdata.user_id, data);
            }

            if (response.status === 200 || response.status === 201) {
                alert('Consecutivo Factura guardado exitosamente');
                setConsecutivo(response.data);
            }
        } catch (error) {
            alert('Error al guardar Factura: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleSubmitNC = async (e) => {
        e.preventDefault();
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const data = { prefijo: prefijoNC, consecutivo: numeroConsecutivoNC };

        try {
            let response;
            if (consecutivoNC) {
                response = await axios.put('/consecutivo-nc-no-electronica?uid=' + userdata.user_id, data);
            } else {
                response = await axios.post('/consecutivo-nc-no-electronica?uid=' + userdata.user_id, data);
            }

            if (response.status === 200 || response.status === 201) {
                alert('Consecutivo Nota Crédito guardado exitosamente');
                setConsecutivoNC(response.data);
            }
        } catch (error) {
            alert('Error al guardar Nota Crédito: ' + (error.response?.data?.message || error.message));
        }
    };

    if (!loggedIn || loading) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="settings" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item"><Link to="/administrar-tratamientos">Administrador Contable</Link></li>
                                    <li className="breadcrumb-item active">Parámetros Factura No Electrónica</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Parámetros No Electrónicos</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            {/* Sección Factura de Venta */}
                            <div className="col-md-6">
                                <div className="card card-info card-outline">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            <i className="fas fa-file-invoice"></i> Consecutivo Factura Venta
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmitFactura}>
                                            <div className="form-group">
                                                <label>Prefijo (Opcional)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={prefijo}
                                                    onChange={(e) => setPrefijo(e.target.value)}
                                                    placeholder="Ej: FNE"
                                                    maxLength="10"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Consecutivo Actual *</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={numeroConsecutivo}
                                                    onChange={(e) => setNumeroConsecutivo(e.target.value)}
                                                    min="1"
                                                    required
                                                />
                                            </div>

                                            <div className="alert alert-light border">
                                                <strong>Vista Previa:</strong> {prefijo ? `${prefijo}-${String(numeroConsecutivo).padStart(4, '0')}` : String(numeroConsecutivo).padStart(4, '0')}
                                            </div>

                                            <button type="submit" className="btn btn-info btn-block">
                                                <i className="fas fa-save"></i> Guardar Factura
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {/* Sección Nota Crédito */}
                            <div className="col-md-6">
                                <div className="card card-danger card-outline">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            <i className="fas fa-file-invoice-dollar"></i> Consecutivo Nota Crédito
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmitNC}>
                                            <div className="form-group">
                                                <label>Prefijo (Opcional)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={prefijoNC}
                                                    onChange={(e) => setPrefijoNC(e.target.value)}
                                                    placeholder="Ej: NC"
                                                    maxLength="10"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Consecutivo Actual *</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={numeroConsecutivoNC}
                                                    onChange={(e) => setNumeroConsecutivoNC(e.target.value)}
                                                    min="1"
                                                    required
                                                />
                                            </div>

                                            <div className="alert alert-light border">
                                                <strong>Vista Previa:</strong> {prefijoNC ? `${prefijoNC}-${String(numeroConsecutivoNC).padStart(4, '0')}` : String(numeroConsecutivoNC).padStart(4, '0')}
                                            </div>

                                            <button type="submit" className="btn btn-danger btn-block">
                                                <i className="fas fa-save"></i> Guardar Nota Crédito
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card card-warning card-outline mt-3">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-exclamation-triangle"></i> Información Importante
                                </h3>
                            </div>
                            <div className="card-body p-3">
                                <ul className="mb-0">
                                    <li>Los consecutivos se incrementan automáticamente al generar documentos.</li>
                                    <li>Modificar estos valores afectará la próxima numeración generada.</li>
                                    <li>Asegúrese de diferenciar los prefijos para evitar confusiones.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="mt-3">
                            <Link to="/administrar-tratamientos" className="btn btn-secondary">
                                <i className="fas fa-arrow-left"></i> Volver al Menú
                            </Link>
                        </div>

                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ParametrosFacturaNoElectronica;
